import { API } from "../../utils/http";

function toApiError(e) {
	if (e?.code === "ERR_NETWORK") return { message: "Network error" };
	return e?.response?.data?.error || { message: e?.message || "Unexpected error" };
}

export function listAgencyTasksApi(params = {}) {
	return API.get("agency-tasks", { params })
		.then((r) => r.data)
		.catch((e) => Promise.reject(toApiError(e)));
}

export function getAgencyTaskApi(taskId) {
	return API.get(`agency-tasks/${taskId}`)
		.then((r) => r.data)
		.catch((e) => Promise.reject(toApiError(e)));
}

export function createAgencyTaskApi(request) {
	return API.post("agency-tasks", request)
		.then((r) => r.data)
		.catch((e) => Promise.reject(toApiError(e)));
}

export function updateAgencyTaskApi(taskId, request) {
	return API.put(`agency-tasks/${taskId}`, request)
		.then((r) => r.data)
		.catch((e) => Promise.reject(toApiError(e)));
}

export function cancelAgencyTaskApi(taskId) {
	return API.put(`agency-tasks/${taskId}/cancel`, {})
		.then((r) => r.data)
		.catch((e) => Promise.reject(toApiError(e)));
}

export function deleteAgencyTaskApi(taskId) {
	return API.delete(`agency-tasks/${taskId}`)
		.then((r) => r.data)
		.catch((e) => Promise.reject(toApiError(e)));
}

export function addAgencyTaskMessageApi(taskId, request) {
	return API.put(`agency-tasks/${taskId}/messages`, request)
		.then((r) => r.data)
		.catch((e) => Promise.reject(toApiError(e)));
}

export function listAgencyTaskAssigneesApi() {
	return API.get("agency-tasks/assignees")
		.then((r) => r.data)
		.catch((e) => Promise.reject(toApiError(e)));
}

export function deleteAgencyTaskAssigneeApi(normalizedName) {
	return API.delete(`agency-tasks/assignees/${encodeURIComponent(normalizedName)}`)
		.then((r) => r.data)
		.catch((e) => Promise.reject(toApiError(e)));
}
